import { dateFromString, discountPercentFromFactor } from '@retail/utils';
import {
  ConditionBindingMinimal,
  CustomerMarkupConditionNewDTO,
} from '../../dtos/ConditionsNewDTO';

interface CustomerMarkupConditionProps {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  percent: number;
  salesFactor?: number;
  discountPercent: number;
  validFrom: Date;
  validTo?: Date;
}

export class CustomerMarkupConditionNew {
  conditionId: number;
  isInherited: boolean;
  inheritedBinding?: ConditionBindingMinimal;
  isDeletionCondition: boolean;
  percent: number;
  salesFactor?: number;
  discountPercent: number;
  validFrom: Date;
  validTo?: Date;

  constructor({
    conditionId,
    isInherited,
    inheritedBinding,
    isDeletionCondition,
    percent,
    salesFactor,
    discountPercent,
    validFrom,
    validTo,
  }: CustomerMarkupConditionProps) {
    this.conditionId = conditionId;
    this.isInherited = isInherited;
    this.inheritedBinding = inheritedBinding;
    this.isDeletionCondition = isDeletionCondition;
    this.percent = percent;
    this.salesFactor = salesFactor;
    this.discountPercent = discountPercent;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDto = (dto: CustomerMarkupConditionNewDTO): CustomerMarkupConditionNew => {
    return new CustomerMarkupConditionNew({
      conditionId: dto.conditionId,
      isInherited: dto.isInherited,
      inheritedBinding: dto.inheritedBinding,
      isDeletionCondition: dto.isDeletionCondition,
      percent: dto.percent,
      salesFactor: dto.salesFactor,
      discountPercent: dto.discountPercent ?? discountPercentFromFactor(dto.salesFactor),
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
    });
  };
}
